export const TRACKING_LOADING = 'TRACKING_LOADING';
export const TRACKING_ERROR = 'TRACKING_ERROR';
export const TRACKING_FINISHED = 'TRACKING_FINISHED';
